export default __webpack_public_path__ + "static/media/icon.charging cords.c3e7afb8.svg";